module.exports = __webpack_public_path__ + "static/media/user-icon-blue.da71ea94.svg";